(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("NJ", [], factory);
	else if(typeof exports === 'object')
		exports["NJ"] = factory();
	else
		root["NJ"] = factory();
})(window, function() {
return 